import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'procure-page-body',
  templateUrl: './page-body.component.html',
  styleUrl: './page-body.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageBody {}
